import PropTypes from 'prop-types';
import Wrapper from '../common/Wrapper/Wrapper';
import {
  StyledFooter,
  StyledFooterCopy,
  StyledFooterDescription,
  StyledFooterText,
  StyledCopyLink,
  StyledFoooterList,
  StyledFooterCategory,
  StyledFooterItem,
  StyledFooterLink,
  StyledFooterAnchor,
  StyledButton,
} from './Footer.styles';
import { Icon } from '../common/Icons';

function Footer({ data }) {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!Object.entries(data).length) return null;

  return (
    <StyledFooter>
      <Wrapper>
        {data.description && (
          <StyledFooterDescription>
            <Icon.Logo aria-hidden />
            {data.description.text && <StyledFooterText>{data.description.text}</StyledFooterText>}
            {data.description.copyright && (
              <StyledFooterCopy>
                &copy;
                {data.description.copyright}
                <StyledCopyLink href={data.description.link} target="_blank">
                  {` ${data.description.poweredBy}`}
                </StyledCopyLink>
              </StyledFooterCopy>
            )}
          </StyledFooterDescription>
        )}
        {data.linkGroups &&
          data.linkGroups.map(linkGroup => (
            <StyledFoooterList key={linkGroup.id}>
              <StyledFooterCategory>{linkGroup.heading}</StyledFooterCategory>
              {linkGroup.links.map(link =>
                link.external ? (
                  <StyledFooterItem key={link.id}>
                    <StyledFooterAnchor href={link.to} target="_blank">
                      {link.text}
                    </StyledFooterAnchor>
                  </StyledFooterItem>
                ) : (
                  <StyledFooterItem key={link.id}>
                    <StyledFooterLink to={link.to}>{link.text}</StyledFooterLink>
                  </StyledFooterItem>
                )
              )}
            </StyledFoooterList>
          ))}
        <StyledButton onClick={scrollToTop}>
          <Icon.Arrow aria-hidden />
          Go to Top
        </StyledButton>
      </Wrapper>
    </StyledFooter>
  );
}

Footer.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.shape({
      text: PropTypes.string,
      poweredBy: PropTypes.string,
      link: PropTypes.string,
    }),
    linkGroups: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        heading: PropTypes.string,
        links: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            text: PropTypes.string,
            to: PropTypes.string,
            external: PropTypes.bool,
          })
        ),
      })
    ),
  }),
};

Footer.defaultProps = {
  data: {},
};

export default Footer;
